import { type FC } from "react";
import { BiSolidLogOut } from "react-icons/bi";
import { GiHamburgerMenu } from "react-icons/gi";
import { NavLink } from "react-router-dom";
import { MoonLoader } from "react-spinners";
import logoNav from "../../images/logonav.png";
import logoLetra from "../../images/logoLetra.png";
import { useNavbar } from "./navbarHooks";

export const Navbar: FC = () => {
  const {
    isMobileMenuOpen,
    mobileMenuAnimationClass,
    currentPath,
    isLogouting,
    navItems,
    handleGoHome,
    handleToggleNavbar,
    handleCloseNavbar,
    handleLogout,
  } = useNavbar();

  return (
    <>
      <div className="fixed w-full lg:px-16 z-10 px-6 flex justify-between items-center lg:py-0 py-2 bg-white shadow-[2px_0px_6px_rgb(0,0,0,0.5)]">
        <img
          src={logoNav}
          alt="logo"
          className="w-[40px] h-[40px] cursor-pointer"
          onClick={handleGoHome}
        />

        <img src={logoLetra} alt="logo" className="w-[180px] lg:hidden" />

        <GiHamburgerMenu
          onClick={handleToggleNavbar}
          className="lg:hidden flex-none"
          size={26}
        />

        <div className="hidden lg:flex items-center w-auto " id="menu">
          <nav>
            <ul className="lg:flex items-center justify-between text-base text-gray-700 pt-4 lg:pt-0">
              {navItems.map((item) => (
                <li key={item.path}>
                  <NavLink
                    className="lg:p-4 py-3 px-0 block border-b-2 border-transparent hover:border-indigo-400"
                    to={item.path}
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}

              <li>
                <button
                  type="button"
                  className="bg-[#8131bd] w-fit px-2 font-semibold text-white py-1 rounded-3xl flex justify-center items-center min-w-[80px]"
                  onClick={handleLogout}
                  disabled={isLogouting}
                >
                  <BiSolidLogOut className="mr-2" size={16} />
                  {isLogouting ? (
                    <MoonLoader size={20} color="#ffffff" />
                  ) : (
                    "Salir"
                  )}
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      {isMobileMenuOpen ? (
        <div
          className={`z-30 w-[95%] flex flex-col pt-4 px-7 h-[600px] bg-white mt-[60px] fixed animate__animated ${mobileMenuAnimationClass}`}
        >
          <>
            {navItems.map((item) => {
              const Icon = item.icon;

              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  onClick={handleCloseNavbar}
                  className={`w-full flex items-center px-5 font-semibold text-lg py-3 rounded-3xl ${
                    currentPath === item.path ? "bg-[#8131bd] text-white" : ""
                  }`}
                >
                  <Icon className={`mr-2 ${item.iconClassName ?? ""}`.trim()} size={25} />
                  {item.mobileLabel}
                </NavLink>
              );
            })}

            <button
              type="button"
              className="bg-[#8131bd] text-lg mt-4 w-fit px-5 font-semibold text-white py-3 rounded-3xl flex justify-center items-center min-w-[80px]"
              onClick={handleLogout}
              disabled={isLogouting}
            >
              <BiSolidLogOut className="mr-2" size={25} />
              {isLogouting ? (
                <MoonLoader size={20} color="#ffffff" />
              ) : (
                "Cerrar Sesion"
              )}
            </button>
          </>
        </div>
      ) : null}
    </>
  );
};
